import script from "./OrderPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPayment.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPayment.vue?vue&type=style&index=0&id=5e24fdf4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e24fdf4"]])

export default __exports__